export default function Skills() {
  const skills = {
    AI_ML: [
      'GANs - Coursera',
      'Computer Vision Basics - Coursera',
      'Transformer Models & BERT - Coursera',
      'Mathematics for ML - Coursera'
    ],
    DataScience: [
      'Data Analysis with Python – Coursera',
      'Data Science Intro – CISCO',
      'Visualization with Power BI – Great Learning',
      'Advanced NLP with spaCy – Datacamp'
    ],
    Programming: [
      'Python NLTK for beginners - Coursera',
      'Java OOP - UC San Diego',
      'Java Structured Data - Duke University'
    ],
    Platforms: [
      'Salesforce Basics - Trailhead',
      'Build Lightning Web Components - Trail'
    ]
  };

  return (
    <section className="bg-gray-800 text-white py-12 px-4" id="skills">
      <h2 className="text-3xl font-bold text-center mb-8">Skills</h2>
      <div className="space-y-8">
        {Object.entries(skills).map(([category, items]) => (
          <div key={category}>
            <h3 className="text-xl font-semibold mb-4">{category.replace('_', ' ')}</h3>
            <div className="flex flex-wrap gap-3">
              {items.map((item, index) => (
                <span key={index} className="bg-blue-600 px-4 py-2 rounded-full text-sm">
                  {item}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
